const usd = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Amounts arrive from the server as strings. Only converted to a number right before display. */
export function formatMoney(value: string): string {
  return usd.format(Number(value));
}

type UnitInfo = { unit: string; isDivisible: boolean };

/**
 * Quantities arrive from the server as strings like "97.500". Only trimmed right before display.
 * Non-divisible units are written attached like "3박스"; weight units are spaced like "97.5 lb".
 */
export function formatQty(qty: string, sku: UnitInfo): string {
  if (!sku.isDivisible) {
    return `${Math.round(Number(qty)).toLocaleString("ko-KR")}${sku.unit}`;
  }
  const trimmed = qty.includes(".") ? qty.replace(/0+$/, "").replace(/\.$/, "") : qty;
  return `${trimmed} ${sku.unit}`;
}

/** For invoices. Fixes decimal places so lines align vertically. */
export function formatQtyExact(qty: string, sku: UnitInfo): string {
  if (!sku.isDivisible) {
    return `${Math.round(Number(qty)).toLocaleString("ko-KR")}${sku.unit}`;
  }
  return `${Number(qty).toFixed(3)} ${sku.unit}`;
}

const dateTime = new Intl.DateTimeFormat("ko-KR", {
  month: "long",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  timeZone: "America/Los_Angeles",
});

export function formatDateTime(iso: string): string {
  return dateTime.format(new Date(iso));
}

export function formatRelativeDeadline(iso: string, now: Date = new Date()): string {
  const ms = new Date(iso).getTime() - now.getTime();
  if (ms <= 0) return "마감됨";

  const minutes = Math.floor(ms / 60_000);
  const days = Math.floor(minutes / (60 * 24));
  const hours = Math.floor((minutes % (60 * 24)) / 60);
  const mins = minutes % 60;

  if (days > 0) return `${days}일 ${hours}시간 남음`;
  if (hours > 0) return `${hours}시간 ${mins}분 남음`;
  return `${mins}분 남음`;
}
